import { createSelector } from 'reselect'

import { getCockpitMdfSalesFromData } from '../../lib/keyInitiativesTile/getCockpitMdfSalesFromData'

import { selectCockpitCategory } from './selectCockpitCategory'
import { selectCockpitMetric } from './selectCockpitMetric'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectEffectiveCockpitFYear } from './selectEffectiveCockpitFYear'
import { selectFinancialCockpitState } from './selectFinancialCockpitState'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectCockpitMdfSales = createSelector(
  [
    selectFinancialCockpitState,
    selectVisibleCockpitPartnerData,
    selectEffectiveCockpitFYear,
    selectCockpitOffering,
    selectCockpitCategory,
    selectCockpitMetric,
  ],
  ({ mdfSales }, partners, fYear, offering, category, metric) =>
    getCockpitMdfSalesFromData({
      rows: mdfSales,
      partnerIds: partners.map(({ PartnerId }) => PartnerId),
      fYear,
      offering,
      category,
      metric,
    })
)
